import React, { useEffect } from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
// import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DoneIcon from "@mui/icons-material/Done";

// // For Radio button
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";
// // End

import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

function AddSociety() {
  const navigate = useNavigate();

  var formikInitials = {
    // societyName: "",
    buildingCount: 1,
    address: "",
    spotLayout: "",
    google_map_image: "",
    x_axis: "",
    y_axis: "",
    latitude: "",
    longitude: "",
  };

  const Validation_Schema = Yup.object().shape({
    societyName: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    contact: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      )
      .min(10, "phone no must be greater than or equal to 10 digits")
      .max(15, "phone no must be greater than or equal to 10-15 digits")
      .required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    buildingCount: Yup.string()
      .min(1, "Invalid Building count")
      .required("Required"),
    spotLayout: Yup.string().required("Required"),
    google_map_image: Yup.string().required("Required"),
    x_axis: Yup.string().required("Required"),
    y_axis: Yup.string().required("Required"),
    // latitude: Yup.string().required("Required"),
    // longitude: Yup.string().required("Required"),
  });

  const [societyName, setSocietyName] = React.useState("");
  const [societyImage, setSocietyImage] = React.useState("");
  const [contact, setContact] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [buildingCount, setBuildingCount] = React.useState(1);
  const [spotLayout, setSpotLayout] = React.useState("");
  const [google_map_image, setGoogleMapImage] = React.useState("");
  const [x_axis, setXAxis] = React.useState("");
  const [y_axis, setYAxis] = React.useState("");
  const [latitude] = React.useState("");
  const [longitude] = React.useState("");
  const [documentsList, setDocumentsList] = React.useState([]);
  const [Update, setUpdate] = React.useState(false);

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    return fileUrl;
  }

  async function uploadSpotLayout(e) {
    // handle validations
    const file = e.target.files[0];

    if (validateImageOrFile(file)) {
      var documentUrl = await uploadImageOrFile(file);

      setSpotLayout(documentUrl);
    } else swal("Please upload a file with image format only", "", "warning");
  }

  async function uploadGoogleMapImage(e) {
    // handle validations
    const file = e.target.files[0];

    if (validateImageOrFile(file)) {
      var documentUrl = await uploadImageOrFile(file);

      setGoogleMapImage(documentUrl);
    } else swal("Please upload a file with image format only", "", "warning");
  }

  async function uploadSocietyImage(e) {
    // handle validations
    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      var documentUrl = await uploadImageOrFile(file);

      setSocietyImage(documentUrl);
    } else swal("Please upload a file with image format only", "", "warning");
  }

  async function uploadDocuments(e) {
    // handle validations
    const file = e.target.files[0];
    var document = await uploadImageOrFile(file);
    documentsList.push(document);
    setDocumentsList(documentsList);
    setUpdate(!Update);
  }

  async function deleteDocument(index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    setUpdate(!Update);
  }

  async function addSociety() {
    let inputdata = {
      society_name: societyName,
      society_image: societyImage,
      contact: contact,
      email_id: email,
      document_list: documentsList,
      address: address,
      building_count: buildingCount,
      spot_layout: spotLayout,
      google_map_image: google_map_image,
      xaxis_in_meter: x_axis,
      yaxis_in_meter: y_axis,
      ref_latitude: latitude,
      ref_longitude: longitude,
      society_code: localStorage.getItem("societyCode"),
    };

    makePostRequest("society/insert", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          swal("Success", "Society added successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          updateSuperAdmin(response.data.data.society_id);
          localStorage.setItem("socityid", response.data.data.society_id);
          localStorage.setItem(
            "buildingCnt",
            response.data.data.building_count
          );
          // localStorage.removeItem('societyCode')

          navigate("/BuildingYes");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function updateSuperAdmin(society_id) {
    let inputdata = {
      resident_id: localStorage.getItem("userId"),
      society_id: society_id,
    };
    makePostRequest("resident/update", inputdata)
      .then((response) => {
        // checked codition if responce is empty
        if (response.data.data !== undefined) {
        }
      })
      .catch((err) => {});
  }

  useEffect(() => {
    let societyNameFromSchema = sessionStorage
      .getItem("schema")
      .replace("_", " ")
      .toUpperCase();
    console.log(societyNameFromSchema);
    document.getElementById("societyName").value = societyNameFromSchema;
    setSocietyName(societyNameFromSchema);
  }, [Update]);
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">Add Society</h1>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={formikInitials}
          validationSchema={Validation_Schema}
          onSubmit={addSociety}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => (
            <Form>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="residentHeading">Add Society</div>
                  <div className="addSocietyMain">
                    <div className="addSocietyInnerMainNew ">
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={7}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                              <div className="uploadImDiv">
                                <div className="uploadIm">
                                  <img src={societyImage} />
                                </div>
                                <div className="uploadInpu">
                                  <FileUploadIcon />
                                  <span>Upload Society Photo</span>
                                  <input
                                    type="file"
                                    id="profile_pic"
                                    value={values.societyImage}
                                    onChange={(event) =>
                                      uploadSocietyImage(event, "resident")
                                    }
                                  />
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Society Name</label>
                              <input
                                className="inputSt"
                                placeholder="Society Name"
                                id="societyName"
                                value={values.societyName}
                                onChange={handleChange("societyName")}
                                onBlur={() => setFieldTouched("societyName")}
                                onChangeCapture={(e) =>
                                  setSocietyName(e.target.value)
                                }
                              />
                              {errors.societyName && touched.societyName ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.societyName}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Phone Number</label>
                              <input
                                className="inputSt"
                                placeholder="Phone Number"
                                value={values.contact}
                                onChange={handleChange("contact")}
                                onBlur={() => setFieldTouched("contact")}
                                onChangeCapture={(e) =>
                                  setContact(e.target.value)
                                }
                              />
                              {errors.contact && touched.contact ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.contact}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Email Id</label>
                              <input
                                className="inputSt"
                                placeholder="Email Id"
                                value={values.email}
                                onChange={handleChange("email")}
                                onBlur={() => setFieldTouched("email")}
                                onChangeCapture={(e) =>
                                  setEmail(e.target.value)
                                }
                              />
                              {errors.email && touched.email ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.email}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                Building Count
                              </label>
                              <input
                                className="inputSt"
                                placeholder="Building Count"
                                value={values.buildingCount}
                                onChange={handleChange("buildingCount")}
                                onBlur={() => setFieldTouched("buildingCount")}
                                onChangeCapture={(e) =>
                                  setBuildingCount(e.target.value)
                                }
                              />
                              {errors.buildingCount && touched.buildingCount ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.buildingCount}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Address</label>
                              <input
                                className="inputSt"
                                placeholder="Address"
                                value={values.address}
                                onChange={handleChange("address")}
                                onBlur={() => setFieldTouched("address")}
                                onChangeCapture={(e) =>
                                  setAddress(e.target.value)
                                }
                              />
                              {errors.address && touched.address ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.address}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Spot Layout</label>
                              <div className="uploadImgOut inputSt upLoadStInpt">
                                <span className="imgName">
                                  {spotLayout
                                    .split("/")
                                    .pop()
                                    .replace("%20", " ")}
                                </span>
                                <input
                                  type="file"
                                  value={values.spotLayout}
                                  onChange={(event) => uploadSpotLayout(event)}
                                />
                                <UploadIcon />
                                {errors.spotLayout && touched.spotLayout ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.spotLayout}
                                  </div>
                                ) : null}
                              </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Google Map</label>
                              <div className="uploadImgOut inputSt upLoadStInpt">
                                <span className="imgName">
                                  {google_map_image
                                    .split("/")
                                    .pop()
                                    .replace("%20", " ")}{" "}
                                </span>
                                <input
                                  type="file"
                                  placeholder="Google Map"
                                  value={values.google_map_image}
                                  onChange={(event) =>
                                    uploadGoogleMapImage(event)
                                  }
                                />
                                <UploadIcon />
                                {errors.google_map_image &&
                                touched.google_map_image ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.google_map_image}
                                  </div>
                                ) : null}
                              </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                X-Axis in Meter
                              </label>
                              <input
                                className="inputSt"
                                placeholder="X-Axis in Meter"
                                value={values.x_axis}
                                onChange={handleChange("x_axis")}
                                onBlur={() => setFieldTouched("x_axis")}
                                onChangeCapture={(e) =>
                                  setXAxis(e.target.value)
                                }
                              />
                              {errors.x_axis && touched.x_axis ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.x_axis}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                Y-Axis in Meter
                              </label>
                              <input
                                className="inputSt"
                                placeholder="Y-Axis in Meter"
                                value={values.y_axis}
                                onChange={handleChange("y_axis")}
                                onBlur={() => setFieldTouched("y_axis")}
                                onChangeCapture={(e) =>
                                  setYAxis(e.target.value)
                                }
                              />
                              {errors.y_axis && touched.y_axis ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.y_axis}
                                </div>
                              ) : null}
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                Reference Latitude
                              </label>
                              <input
                                className="inputSt"
                                placeholder="Reference Latitude"
                                value={values.latitude}
                                onChange={handleChange("latitude")}
                                onBlur={() => setFieldTouched("latitude")}
                                onChangeCapture={(e) =>
                                  setLatitude(e.target.value)
                                }
                              />
                              {errors.latitude && touched.latitude ? (
                                <div style={{ color: "red" }} className="errorField">
                                  {errors.latitude}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                Reference Longitude
                              </label>
                              <input
                                className="inputSt"
                                placeholder="Reference Longitude"
                                value={values.longitude}
                                onChange={handleChange("longitude")}
                                onBlur={() => setFieldTouched("longitude")}
                                onChangeCapture={(e) =>
                                  setLongitude(e.target.value)
                                }
                              />
                              {errors.longitude && touched.longitude ? (
                                <div style={{ color: "red" }} className="errorField">
                                  {errors.longitude}
                                </div>
                              ) : null}
                            </Grid> */}
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={5}>
                          <div className="tabRightDiv">
                            <h4 className="documeUpload documeUploadIcon">
                              Upload Documents
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: 0,
                                  }}
                                  id="documentsList"
                                  value={values.documentsList}
                                  onChange={(event) =>
                                    uploadDocuments(event, "resident")
                                  }
                                  onChangeCapture={() =>
                                    setDocumentsList(documentsList)
                                  }
                                />
                              </Button>
                            </h4>
                            {documentsList ? (
                              <div>
                                {documentsList.map((option, index) => (
                                  <div
                                    id="documentDiv"
                                    className="doqumentDiv1"
                                  >
                                    <span>
                                      {option
                                        .split("/")
                                        .pop()
                                        .replace("%20", " ")}
                                      <DoneIcon className="doneIcon" />{" "}
                                    </span>

                                    <Button
                                      className="documRemove"
                                      onClick={() => deleteDocument(index)}
                                    >
                                      <DeleteForeverIcon className="deleIco" />
                                    </Button>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Button
                            className="addBt"
                            onClick={() => addSociety()}
                          >
                            Save Society Details
                          </Button>
                          {/* <Button
                            className="addBt"
                            onClick={() => navigate("/BuildingYes")}
                          >
                            Add
                          </Button> */}
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}

export default AddSociety;
